import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import {
  PM_V2_Execution_Save_Interface,
  PM_V2_Execution_Context_Interface,
  PM_V2_EmptyExecution
} from '../../../Interface/PM_V2_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';

@Component({
  selector: 'app-pm-v2-execution-add',
  templateUrl: './PM_V2_ExecutionAdd.component.html',
  styleUrls: ['./PM_V2_ExecutionAdd.component.css']
})
export class PM_V2_ExecutionAddComponent implements OnInit {

  AssignmentItemID: number = 0;
  Due: string = '';
  Context: PM_V2_Execution_Context_Interface | null = null;

  Procssing: boolean = false;
  ReturnUrl = '/pm-v2/due';


  Form: FormGroup = this.fb.group({
    Date_Execution: [null],
    Result: ['', Validators.required],
    Numeric_Value: [null],
    Text_Value: [''],
    Comment: ['']
  });

  constructor(
    private fb: FormBuilder,
    private PM_V2_Service: PM_V2_Service,
    private route: ActivatedRoute,
    private Alertify_Service: AlertifyService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '';
    if (/^\/pm-v2\/(?:due|assignment)(?:\?(?:[^#]*))?$/.test(returnUrl) ||
        /^\/pm-v2\/(?:due\/equipment|assignment\/detail)\/[1-9]\d*(?:\?[^#]*)?$/.test(returnUrl)) {
      this.ReturnUrl = returnUrl;
    }
    this.AssignmentItemID = Number(this.route.snapshot.paramMap.get('id') || 0);
    if (this.AssignmentItemID <= 0) {
      this.router.navigate(['/pm-v2/due']);
      return;
    }
    this.PM_V2_Service.GetExecutionContext(this.AssignmentItemID).subscribe(data => {
      this.Context = data;
      this.Due = data.Date_Due || '';
    }, error => this.HandleError(error));
  }

  Save(dateExecution: string) {
    if (this.Form.invalid) {
      this.Form.markAllAsTouched();
      this.Alertify_Service.ErrorMessage('نتیجه اجرا را مشخص کنید.');
      return;
    }

    const value = this.Form.getRawValue();
    const execution = PM_V2_EmptyExecution();

    execution.PM_V2_Assignment_Item_ID = this.AssignmentItemID;
    execution.Date_Due = this.Due || null;
    execution.Date_Execution = value.Date_Execution || null;
    execution.Result = value.Result || '';
    execution.Numeric_Value =
      value.Numeric_Value === '' || value.Numeric_Value == null
        ? null
        : Number(value.Numeric_Value);
    execution.Text_Value = value.Text_Value || '';
    execution.Comment = value.Comment || '';

    const request: PM_V2_Execution_Save_Interface = {
      model: execution,
      Date_Execution_Persian: (dateExecution || '').trim() || null
    };

    this.Procssing = true;

    this.PM_V2_Service.AddExecution(request).subscribe(
      data => {
        this.Procssing = false;
        this.router.navigateByUrl(this.ReturnUrl);
      },
      error => this.HandleError(error)
    );
  }

  Back() {
    this.router.navigateByUrl(this.ReturnUrl);
  }

  private HandleError(error: any) {
    this.Procssing = false;


    this.Alertify_Service.ErrorMessage('خطا در ثبت اجرای PM.');
  }

  formatPersianDate(value: any): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '-';
    }

    return new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  }
}
